import { Pipe, PipeTransform } from '@angular/core';
import { Todos } from '../models/todos';

@Pipe({
  name: 'paginator'
})
export class PaginatorPipe implements PipeTransform {

  transform(todos: Todos[], page: number = 0, search: string = ''): Todos[] {
    
    if (search.length === 0 ){
      return todos.slice(page,page + 20);
    }

    if (search === 'status'){
      search = 'completed';
    }

    const filteredTodos = todos.sort(this.predicateBy(search))
    return filteredTodos.slice(page,page + 20);
  }

  predicateBy(prop){
    return function(a,b){
       if (a[prop] > b[prop]){
           return 1;
       } else if(a[prop] < b[prop]){
           return -1;
       }
       return 0;
    }
 }

}
